// Referral Outcome Report
export const EmployeeId = "EmployeeId";

// Summary
export const FitnessOutcome = "FitnessOutcome";
export const JustificationForEqualityActOpinion = "JustificationForEqualityActOpinion";
